module.exports = __webpack_public_path__ + "static/media/recovery_sent.4a84a30b.svg";